import type { FacilityCategoryEntry } from "@lib/logic";

import { AreaCell } from "../../workspaces/AreaCell";
import { RoomCell } from "../../rooms/RoomCell";
import { FacilityCell } from "../FacilityCell";

type FacilityCategoryEntryCellProps = {
  entry: FacilityCategoryEntry;
};

export const FacilityCategoryEntryCell = ({ entry }: FacilityCategoryEntryCellProps) => {
  switch (entry.kind) {
    case "area":
      return <AreaCell area={entry.area} />;
    case "room":
      return <RoomCell room={entry.room} />;
    case "facility":
      return <FacilityCell facility={entry.facility} />;
  }
};
